import Decimal from 'decimal.js';

import { isNumber } from './primitives';

const median = (data: number[] = []) => {
  const mid = Math.floor(data.length / 2);
  const nums = [...data].sort((a, b) => a - b);

  if (data.length % 2 !== 0) {
    return nums[mid];
  }

  const num = new Decimal(nums[mid - 1]).plus(nums[mid]);

  return num.div(2).toNumber();
};

const validateValues = (data: number[] = []) => data.map((value) => (isNumber(value) ? value : 0));

export const mm = (data: number[] = [], period: number): any => {
  const len = data.length;

  if (!len) {
    return data;
  }

  if (!isNumber(period)) {
    return data;
  }

  if (period === 0) {
    return data;
  }

  if (period > len) {
    return Array(len);
  }

  const res = [];
  let start = 1 - period;

  for (let i = 0; i < len; i += 1) {
    if (start < 0) {
      res.push(undefined);
    } else {
      const v = data.slice(start, start + period);
      const values = validateValues(v);
      const medianValue = median(values);

      res.push(medianValue);
    }

    start += 1;
  }

  return res;
};
